<template>
    <div class="panel">
        <div class="third-text-row">
            <span class="subtitle">LINC</span>
            {{ siteDetails.LINC }}
        </div>
        <div
            v-if="siteDetails.ATSsCount"
            class="third-text-row"
        >
            <span class="subtitle">Alberta Township System (ATS) </span>
            <div
                v-for="(lldDetails, index) in siteDetails.LLD"
                :key="index"
            >
                <div
                    v-if="lldDetails.ATS"
                    class="atc"
                >
                    <div
                        class="sect"
                    >
                        W
                    </div>
                    <div class="sect data">
                        <span class="val">{{ lldDetails.MER }}</span>
                        <span class="desc">MER</span>
                        <span class="desc2">(Meridian)</span>
                    </div>
                    <div class="sect">
                        -
                    </div>
                    <div class="sect data">
                        <span class="val">{{ lldDetails.RGE }}</span>
                        <span class="desc">RGE</span>
                        <span class="desc2">(Range)</span>
                    </div>
                    <div class="sect">
                        -
                    </div>
                    <div class="sect data">
                        <span class="val">{{ lldDetails.TWP }}</span>
                        <span class="desc">TWP</span>
                        <span class="desc2">(Township)</span>
                    </div>
                    <div class="sect">
                        -
                    </div>
                    <div class="sect data">
                        <span class="val">{{ lldDetails.SEC }}</span>
                        <span class="desc">SEC</span>
                        <span class="desc2">(Section)</span>
                    </div>
                    <div class="sect">
                        -
                    </div>
                    <div class="sect data">
                        <span class="val">NW</span>
                        <span class="desc">QTR</span>
                        <span class="desc2">(Quarter Section)</span>
                    </div>
                    <div class="sect">
                        -
                    </div>
                    <div class="sect data">
                        <span class="val">1</span>
                        <span class="desc">LSD</span>
                        <span class="desc2">(Legal Subdivision)</span>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="siteDetails.PBLsCount"
            class="third-text-row"
        >
            <span class="subtitle">Plan, Block, Lot (PBL)</span>
            <div
                v-for="(lldDetails, index) in siteDetails.LLD"
                :key="index"
            >
                <div
                    v-if="lldDetails.PBL"
                    class="pbl"
                >
                    <div class="sect data">
                        <span class="val"> {{ lldDetails.Plan }} </span>
                        <span class="desc">Plan</span>
                    </div>
                    <div class="sect">
                        -
                    </div>
                    <div class="sect data">
                        <span class="val"> {{ lldDetails.Block }} </span>
                        <span class="desc">Block</span>
                    </div>
                    <div class="sect">
                        -
                    </div>
                    <div class="sect data">
                        <span class="val">{{ lldDetails.Lot }}</span>
                        <span class="desc">Lot</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="third-text-row">
            <span class="subtitle">Municipality</span>
            {{ siteDetails.municipality }}
        </div>
        <div class="third-text-row">
            <span class="subtitle">Environment Consulting Company</span>
            {{ siteDetails.environmentalConsultingCompany }}
        </div>
        <div class="third-text-row">
            <span class="subtitle">Is there a Record of Site Condition</span>
            {{ siteDetails.isThereRecordOfSiteCondition }}
        </div>
        <div class="third-text-row">
            <span class="subtitle">Status of Record of Site Condition</span>
            {{ siteDetails.statusOfSiteConditionRecord }}
        </div>
        <div class="third-text-row">
            <span class="subtitle">Rationale for Site Status</span>
            {{ siteDetails.rationaleForSiteStatus }}
        </div>
        <div class="third-text-row">
            <span class="subtitle">Site Criteria Selection</span>
            {{ siteDetails.siteCriteriaSelection }}
        </div>
        <div class="third-text-row">
            <span class="subtitle">Year of the Criteria Selection</span>
            {{ siteDetails.yearOfCriteriaSelection }} <br> {{ siteDetails.criteriaCommentForSite }}
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

export default defineComponent({
    name: 'SiteInformation',
    components: {},
    props: {
        siteDetails: ESARSite
    },
    setup() {
    }
});
</script>

<style lang="postcss" scoped>
.panel {
    .title {
        @apply flex items-baseline justify-between mt-2 mb-2;
    }

    .content {
        @apply mt-4;
    }

    /** Elements */
    .title {
        @apply text-lg font-bold;
    }

    .subtitle {
        @apply text-sm font-bold;
    }

    .atc, .pbl {
        @apply flex flex-grow;

        .sect {
            @apply flex flex-col text-center;

            &.data {
                @apply flex-grow;

                .val {
                    border-bottom: 1px solid #000;
                }
            }
        }

        .desc {
            @apply font-bold;
            font-size: 0.6rem;
        }

        .desc2 {
            font-size: 0.6rem;
        }
    }

    .pbl {
        @apply flex-grow-0;
        /*width: 30%;*/
    }

    /** Row Types */
    .third-text-row {
        @apply flex text-sm mb-3 flex-wrap;
    }

    .third-text-row {
        .subtitle {
            @apply w-1/3 mr-2;
        }
    }
}
</style>
